import { createFileRoute } from '@tanstack/react-router';
import ObjectsIndexPage from '@/pages/workspaces/objects/index.page';
import { ObjectsMigrationRoute } from '@/pages/workspaces/objects/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/objects/')({
  component: () => (
    <ObjectsMigrationRoute>
      <ObjectsIndexPage />
    </ObjectsMigrationRoute>
  ),
});
